import type {NavGroup} from '@academy/components';

import {theme} from '@academy/utils';

const navLinks: Record<string, NavGroup[]> = {
    default: [
        {
            title: 'footer.nav.about-us-title',
            links: [
                {
                    title: 'footer.nav.about-us.careers',
                    routeName: '/home',
                    isOuterLink: false,
                },
                {
                    title: 'footer.nav.about-us.who-we-are',
                    routeName: 'https://smartsafeschool.com',
                    isOuterLink: true,
                },
            ],
        },
        {
            title: 'footer.nav.for-business-title',
            links: [
                {
                    title: 'footer.nav.for-business.become-a-vendor',
                    routeName: '/for-business',
                    isOuterLink: false,
                },
                {
                    title: 'footer.nav.for-business.log-in',
                    routeName: '/login',
                    isOuterLink: false,
                },
            ],
        },
        {
            title: 'footer.nav.for-investors-title',
            links: [
                {
                    title: 'footer.nav.for-investors.become-an-investor',
                    routeName: '/for-investors',
                    isOuterLink: false,
                },
            ],
        },
        {
            title: 'footer.nav.help-title',
            links: [
                {
                    title: 'footer.nav.help.support',
                    routeName: '/home',
                    isOuterLink: false,
                },
                {
                    title: 'footer.nav.help.payment',
                    routeName: '/login',
                    isOuterLink: false,
                },
                {
                    title: 'footer.nav.help.faq',
                    routeName: '/login',
                    isOuterLink: false,
                },
            ],
        },
    ],
    kids: [
        {
            links: [
                {
                    title: 'for-schools-page.title',
                    routeName: '/for-schools',
                    isOuterLink: false,
                },
            ],
        },
        {
            links: [
                {
                    title: 'for-families-page.title',
                    routeName: '/for-families',
                    isOuterLink: false,
                },
                {
                    title: 'for-providers-page.title',
                    routeName: '/for-providers',
                    isOuterLink: false,
                },
            ],
        },
        {
            links: [
                {
                    title: 'common.programs',
                    routeName: '/programs',
                    isOuterLink: false,
                },
                {
                    title: 'common.about-us',
                    routeName: '/about',
                    isOuterLink: false,
                },
            ],
        },
        {
            links: [
                {
                    title: 'footer.nav.terms-of-use',
                    routeName: '/agreement-user',
                    isOuterLink: true,
                },
                {
                    title: 'footer.nav.policy',
                    routeName: '/privacy',
                    isOuterLink: true,
                },
            ],
        },
    // {
    //   links: [
    //     {
    //       title: "footer.nav.shipping-returns",
    //       routeName: "/shipping-returns",
    //       isOuterLink: true,
    //     },
    //     {
    //       title: "footer.nav.terms-of-use-partners",
    //       routeName: "/agreement-partner",
    //       isOuterLink: false,
    //       //@ts-ignore
    //       disabled: true,
    //     },
    //   ],
    // },
    ],
};

export default navLinks[theme] || navLinks.default;
